export function notFound() {
  throw new Response("Not Found", { status: 404 });
}
